/**
 * @generated SignedSource<<59b64104f36bc3fe75a8fcdfe522f4ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TemplatesFavorite_flow$data = {
  readonly flowFavorites: {
    readonly nodes: ReadonlyArray<{
      readonly flowId: UUID;
    }>;
  };
  readonly rowId: UUID;
  readonly " $fragmentType": "TemplatesFavorite_flow";
};
export type TemplatesFavorite_flow$key = {
  readonly " $data"?: TemplatesFavorite_flow$data;
  readonly " $fragmentSpreads": FragmentRefs<"TemplatesFavorite_flow">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "gwtUserId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TemplatesFavorite_flow",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "gwtUserId",
              "variableName": "gwtUserId"
            }
          ],
          "kind": "ObjectValue",
          "name": "condition"
        }
      ],
      "concreteType": "FlowFavoritesConnection",
      "kind": "LinkedField",
      "name": "flowFavorites",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FlowFavorite",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "flowId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Flow",
  "abstractKey": null
};

(node as any).hash = "0831dfaca845de4f663b9f64bdb4fde3";

export default node;
